import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { AuthService } from "../../services/auth.service"
import { FlashMessagesService } from 'ngx-flash-messages';
import { Router } from "@angular/router";

@Component({
  selector: 'app-addmall',
  templateUrl: './addmall.component.html',
  styleUrls: ['./addmall.component.scss']
})
export class AddmallComponent implements OnInit {

  name:any;
  user:any;
  loc:any;
  lat:any;
  lng:any;
  image:any;
  active:boolean;

  constructor(
    private location: Location,
    private authservice: AuthService,
    private flashmessage: FlashMessagesService,
    private router:Router
  ) { }

  ngOnInit() {
  }

  onMallSubmit(){
    const mall ={
      name: this.name,
      user:this.user,
      location:this.loc,
      lat:this.lat,
      lng:this.lng,
      image:this.image,
      active:this.active,
    }
    this.authservice.addMall(mall).subscribe(data =>{
         this.flashmessage.show('Successfully Added',
         { classes:['alert-success'] , timeout: 2000});
         this.router.navigate(['/malls']);
      
    } ,error =>{
      this.flashmessage.show('Oops Something went wrong !',
      { classes:['alert-danger'] , timeout: 3000});
    });
  };

  cancel(){
    this.location.back();
  }

}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/malls/addmall/addmall.component.ts